//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import {
  formatDateDDMMYYYY,
} from '../../common/functions/date-utils';
import AnoFiscalPeriodos from './AnoFiscalPeriodos';
import AnoFiscalPeriodosOrcamento from './AnoFiscalPeriodosOrcamento';
import AnoFiscalTipoEvento from './AnoFiscalTipoEvento';
import Confirm from '../../shared-components/vuetify/dialog/Confirm';

export default {
  name: 'AnoFiscalForm',
  mixins: [AnoFiscalTipoEvento],
  data() {
    return {
      anoFiscal: {},
      periodos: [],
      periodosOrcamento: [],
      periodosSincronizados: false,
      tipo: {},
      tipoOrcamento: {},
      menuDataInicio: false,
      dataPrevistaFim: '',
      qtdDiasAddDataInicio: 0,
      dataInicio: {
        type: String,
        default: null,
      },
      formato: 'YYYY-MM-DD',
      formatoSalvar: 'YYYY-MM-DD',
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
        validDate: value => (!value || (value.length === 10 && this.moment(value, 'DD-MM-YYYY').isValid())) || this.$t('message.data_invalida'),
      },
      resourcesAnoFiscal: this.$api.anoFiscal(this.$resource),
      resourcesOrcamentoTipoVerba: this.$api.orcamentoTipoVerba(this.$resource),
    };
  },
  computed: {
    dataInicioFormatada: {
      get() {
        return formatDateDDMMYYYY(this.dataInicio);
      },
      set(newValue) {
        this.dataInicio = parseDateYYYYMMDD(newValue);
      },
    },
  },
  props: {
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
    fecharDepoisSalvar: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    tratarAlteracaoPeriodo(dataFim) {
      if (dataFim > this.anoFiscal.dataPrevistaFim) {
        this.anoFiscal.dataPrevistaFim = dataFim;
        this.dataPrevistaFim = formatDateDDMMYYYY(this.anoFiscal.dataPrevistaFim);
        if (this.periodosSincronizados) {
          this.periodosOrcamento = [...this.$refs.periodos.periodos];
        }
      }
    },
    sincronizacaoPeriodos(sincronizarPeriodos) {
      if (sincronizarPeriodos) {
        this.periodosOrcamento = [...this.$refs.periodos.periodos];
      }
      this.periodosSincronizados = sincronizarPeriodos;
    },
    openSaveDialog() {
      this.$refs.confirmDialog.open();
    },
    openDialog(ref) {
      this.$refs[ref].open();
    },
    validarAno() {
      this.$validator.validateAll()
        .then((isValid) => {
          const periodoPreenchido = this.$refs.periodos.getPeriodos().length > 0;
          if (!isValid || !periodoPreenchido) {
            return;
          }
          this.openSaveDialog();
        })
        .catch();
    },
    montarAno() {
      this.idOrigemVerba = this.$route.params.tipo;
      this.mensagem = '';
      this.anoFiscal.idTipoVerba = this.$route.params.tipo;
      this.anoFiscal.descricao = `${this.$tc('label.ano_fiscal')} ${this.anoAtual()}`;
      this.anoFiscal.dataInicio = this.hoje();
      this.dataInicio = this.anoFiscal.dataInicio;
      this.anoFiscal.dataPrevistaFim = '';
      this.buscarTipo();
    },
    hoje() {
      return moment().format(this.formatoSalvar);
    },
    plusOneDay(data) {
      return this.plusNDay(data, 1);
    },
    plusNDay(data, qtd) {
      return moment(data, this.formatoSalvar).add(qtd, 'day').add(1, 'hour').format(this.formatoSalvar);
    },
    anoAtual() {
      return moment().format('YYYY');
    },
    cancel() {
      this.$router.push({ name: 'ano-fiscal' });
    },
    save() {
      this.resourcesAnoFiscal.gravar(this.prepararAnoSalvar())
        .then(() => {
          if (this.fecharDepoisSalvar) {
            this.fecharAnoFiscal(this.$route.params.tipo, this.$route.params.idAnoFechar);
          }
          this.$toast.create(this.$t('message.adicionado_confira_tabela'), 'snack', 5E3);
          this.$router.push({ name: 'ano-fiscal' });
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    alterarFormatoSalvar(data) {
      return moment(data, this.formato).format(this.formatoSalvar);
    },
    prepararAnoSalvar() {
      const anoSalvar = {};
      anoSalvar.idTipoVerba = this.anoFiscal.idTipoVerba;
      anoSalvar.descricao = this.anoFiscal.descricao;
      anoSalvar.dataInicio = this.alterarFormatoSalvar(this.dataInicio);
      anoSalvar.dataPrevistaFim = this.alterarFormatoSalvar(this.anoFiscal.dataPrevistaFim);
      anoSalvar.periodos = [...this.$refs.periodos.getPeriodos()];
      anoSalvar.periodosOrcamento = [...this.$refs.periodosOrcamento.getPeriodos()];
      return anoSalvar;
    },
    buscarTipo() {
      this.resourcesOrcamentoTipoVerba.buscarTipoVerba({ id: this.anoFiscal.idTipoVerba })
        .then((res) => {
          this.tipo = res.data;
        }, (err) => {
          this.$error(this, err);
          this.cancel();
        });
    },
    preencherDataInicio() {
      this.resourcesOrcamentoTipoVerba.ultimoAno({ id: this.anoFiscal.idTipoVerba })
        .then((res) => {
          if (res.data && !this.fecharDepoisSalvar) {
            this.anoFiscal.dataInicio = this.plusOneDay(res.data.dataPrevistaFim);
          } else {
            this.anoFiscal.dataInicio = this.plusNDay(this.hoje());
          }
          this.dataInicio = this.anoFiscal.dataInicio;
          this.$forceUpdate();
        }, (err) => {
          this.$error(this, err);
          this.cancel();
        });
    },
  },
  components: {
    Confirm,
    AnoFiscalPeriodos,
    AnoFiscalPeriodosOrcamento,
  },
  beforeMount() {
    this.montarAno();
  },
  mounted() {
    this.buscarTipo();
    this.preencherDataInicio();
  },
};



// WEBPACK FOOTER //
// ./src/spa/ano-fiscal/AnoFiscalForm.vue?vue&type=script&lang=js&